const types = {
  SET_NUMERO_DOCUMENTO: 'SET_NUMERO_DOCUMENTO',
  SET_ID_TIPO_DOCUMENTO: 'SET_ID_TIPO_DOCUMENTO',
  SET_ID_UNIDADE_ATUAL: 'SET_ID_UNIDADE_ATUAL',
  SET_DATA_ENVIO_INICIO: 'SET_DATA_ENVIO_INICIO',
  SET_DATA_ENVIO_FIM: 'SET_DATA_ENVIO_FIM',
  SET_LISTA_TIPOS_DOCUMENTO: 'SET_LISTA_TIPOS_DOCUMENTO',
  SET_LISTA_UNIDADES_AUTORIZADAS: 'SET_LISTA_UNIDADES_AUTORIZADAS',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  SET_BUSCANDO_DOCUMENTOS_CAIXA_POSTAL: 'SET_BUSCANDO_DOCUMENTOS_CAIXA_POSTAL',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/caixa-postal/mutations-types.js